export enum InlineCommentError {
	INVALID_SELECTION = 'Invalid text selection. Cannot create inline comments on macros (mentions, images, emojis, etc.)',
	FAILED_TO_INSERT_MARK = 'Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex',
	INVALID_ARGUMENT_CREATED_FROM = 'Invalid createdFrom, please specify if created from editor or renderer',
	STALE_SELECTION = 'Selection was made against a stale version of the content',
	NO_ANONYMOUS_ACCESS = 'Anonymous access is not permitted',
	NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF = 'No comments found for the given markerRef',
	NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST = 'No comments found for the given markerRefList',
	NO_VIEW_PERMS = "User doesn't have VIEW permission for this comment",
	NOT_AUTHORIZED = '403 Forbidden, current user not permitted to use Confluence.',
	NOT_AUTHORIZED_COMMENTS = 'User does not have permission to access the comment(s)',
	// Create Reply
	PARENT_NOT_FOUND = 'Parent comment with id %d is not found. Please provide correct parent comment id.',
	INCOMPATIBLE_PARENT_TYPE = 'Incompatible parent type. Please provide comment id.',
	CANNOT_REPLY_TO_DELETED_PARENT = 'Cannot add reply to a deleted comment',
	CANNOT_REPLY_TO_RESOLVED_COMMENT = 'Inline comment in RESOLVED status cannot be replied',
	// Delete
	// This is the error message for a NotFoundException only
	DELETE_ERROR = 'Exception occurred while deleting comment with id',
	NO_VIEW_OR_MODIFY_PERMS = 'Parent page view is restricted',
	NO_SPACE_PERMS = 'Space is restricted',
	NO_DELETE_WITH_CHILDREN = 'Inline comment with child cannot be deleted.',
	COMMENT_ALREADY_DELETED = 'Exception occurred while deleting comment with id %d',
	ERROR_404 = 'Received status 404',
	// Edit
	NO_UPDATE_PERMS = 'Could not update Content of type  = class com.atlassian.confluence.pages.Comment with id %d',
	UPDATE_COMMENT_NOT_FOUND = 'Could not find Comment for update with id CommentId{id=%d}',
	CANNOT_UPDATE_RESOLVED_COMMENT = 'Inline comment in RESOLVED status cannot be updated',
	// Create
	NO_CREATE_PERMS = 'Could not create content with type comment',
	INVALID_ARGUMENT_MATCHES = 'Invalid arguments provided for matchIndex and/or numMatches',
	CONTENT_OUT_OF_DATE = 'Published Version out of date. Please provide correct published version.',
	UNABLE_TO_APPLY_ANNOTATION = 'Unable to apply annotation to document',
	// Resolve
	CANNOT_RESOLVE_DELETED_COMMENT = '%d must be existing and be an inline comment',
}
